<template>
  <div class="chat-history" ref="history" @scroll="updateScroll">
    <div v-for="(conversation, index) in history" :key="index">
      <div v-if="!datesAreSameDay(index)" class="section-date">
        <div class="date">
          {{ conversation.createdAt | dateChatFormat }}
        </div>
      </div>
      <div v-if="conversation.message.message_type === 'text'">
        <payload-text :conversation="conversation" />
      </div>
      <div v-else-if="conversation.message.message_type === 'buttons'">
        <payload-button :conversation="conversation" />
      </div>
      <div v-else-if="conversation.message.message_type === 'media'">
        <payload-media
          :conversation="conversation"
          @onResendMedia="resendMedia"
          @onRemoveMediaDeliver="removeMediaDeliver"
        />
      </div>
      <div v-else-if="conversation.message.message_type === 'quick_replies'">
        <payload-quick-reply
          :conversation="conversation"
          :isShow="index === history.length - 1"
        />
      </div>
      <div v-else-if="conversation.message.message_type === 'generic'">
        <payload-generic :conversation="conversation" />
      </div>
      <div v-else-if="conversation.message.message_type === 'postback'">
        <payload-postback :conversation="conversation" />
      </div>
      <div v-else>
        <payload-unknown :conversation="conversation" />
      </div>
      <div v-if="isEndSession(index)" class="end-conversation">
        End Conversation
      </div>
    </div>

    <div v-if="previewMessage" class="preview-message" @click="gotoBottom">
      <span
        >You have
        {{ unread === 1 ? `a new message` : `${unread} new messages` }}</span
      >
    </div>
  </div>
</template>

<script>
// import moment from 'moment'

import PayloadText from './payloads/text'
import PayloadButton from './payloads/button'
import PayloadMedia from './payloads/media/index'
import PayloadQuickReply from './payloads/quick_reply'
import PayloadGeneric from './payloads/generic'
import PayloadPostback from './payloads/postback'
import PayloadUnknown from './payloads/unknown'

export default {
  name: 'ChatHistory',
  components: {
    PayloadText,
    PayloadButton,
    PayloadMedia,
    PayloadQuickReply,
    PayloadGeneric,
    PayloadPostback,
    PayloadUnknown
  },
  props: {
    history: Array,
    isSendMessage: Boolean
  },
  watch: {
    history: {
      handler() {
        this.$nextTick(() => {
          if (this.isSendMessage) {
            this.hasScrolledToBottom = true
          }

          if (this.isGetPreviousHistory) {
            this.isGetPreviousHistory = false
            this.$refs.history.scrollTo({
              left: 0,
              top: this.$refs.history.scrollHeight - this.previousScrollHeight,
              behavior: 'instant'
            })
          } else {
            this.scrollToLastMessage()
          }

          this.$parent.markAllAsRead()
        })
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      img: '',
      previewMessage: false,
      unread: 0,
      hasScrolledToBottom: true,
      isGetPreviousHistory: false,
      previousScrollHeight: 0
    }
  },
  methods: {
    updateScroll(el) {
      if (
        el.srcElement.offsetHeight + el.srcElement.scrollTop >=
        el.srcElement.scrollHeight - 60
      ) {
        this.hasScrolledToBottom = true

        if (this.previewMessage) {
          this.unread = 0
          this.previewMessage = false
        }
      } else {
        this.hasScrolledToBottom = false
      }

      if (el.srcElement.scrollTop <= 0) {
        this.previousScrollHeight = this.$refs.history.scrollHeight
        this.isGetPreviousHistory = true
        this.$parent.getPreviousHistory()
      }
    },
    removeMediaDeliver({ deliverId }) {
      this.$emit('onRemoveMediaDeliver', { deliverId })
    },
    resendMedia({ deliverId }) {
      this.$emit('onResendMedia', { deliverId })
    },
    filename(fullname) {
      try {
        let filename = fullname
          .split('?')[0]
          .split('/')
          .pop()

        // return filename
        return decodeURI(filename)
      } catch (error) {
        return ''
      }
    },
    openWindow(url) {
      window.open(url, '_blank')
    },
    sendMessage(message) {
      this.$parent.sendMessage(message)
    },
    sendPostback(title, message) {
      this.$parent.sendPostback(title, message)
    },
    handleButton(button) {
      if (button.type === 'web') this.openWindow(button.payload)
      else if (button.type === 'call') this.openWindow(`tel:${button.payload}`)
      else if (button.type === 'postback')
        this.sendPostback(button.title, button.payload)
      else this.sendMessage(button.title)
    },
    scrollToLastMessage() {
      if (this.hasScrolledToBottom) {
        this.$refs.history.scrollTo({
          left: 0,
          top: this.$refs.history.scrollHeight,
          behavior: 'smooth'
        })

        if (this.previewMessage) {
          this.unread = 0
          this.previewMessage = false
        }

        if (this.isSendMessage) {
          this.$parent.resetSendMessage()
        }
      } else {
        this.unread += 1
        this.previewMessage = true
      }
    },
    datesAreSameDay(currentIndex) {
      if (currentIndex === 0) return false

      if (
        !this.history[currentIndex].createdAt ||
        !this.history[currentIndex - 1].createdAt
      )
        return true

      const first = new Date(this.history[currentIndex - 1].createdAt)
      const second = new Date(this.history[currentIndex].createdAt)

      return (
        first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate()
      )
    },
    isEndSession(currentIndex) {
      if (currentIndex === 0) return false

      if (
        !this.history[currentIndex].session_id ||
        !this.history[currentIndex - 1].session_id
      )
        return false

      const first = this.history[currentIndex - 1].session_id
      const second = this.history[currentIndex].session_id

      return first !== second
    },
    gotoBottom() {
      this.hasScrolledToBottom = true
      this.scrollToLastMessage()
    }
  }
}
</script>
<style lang="scss" scoped></style>
